import React, { cloneElement, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

let openTrayCount = 0;
const BottomTray = ({ children, text, isOpen, setIsOpen, onClose }) => {
  const closeTray = () => {
    setIsOpen(false);
    if (onClose) onClose();
  };

  // Prevent background scroll
  useEffect(() => {
    if (isOpen) {
      openTrayCount++;
      console.log("Me opened", text);
      document.body.style.overflow = "hidden";
    }
    return () => {
      if (isOpen) {
        openTrayCount--;
        console.log("Me removed", text);
        if (openTrayCount === 0) {
          document.body.style.overflow = "";
        }
      }
    };
  }, [isOpen]);

  return (
    <>
      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={closeTray}
              style={{ zIndex: 1052 }}
            />

            <motion.div
              className="position-fixed bottom-0 start-0 w-100 shadow"
              style={{
                zIndex: 1053,
                backgroundColor: "#F2F2F7",
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                touchAction: "none",
              }}
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              drag="y"
              dragConstraints={{ top: 0, bottom: 0 }}
              onDragEnd={(e, info) => {
                if (info.velocity.y > 500 || info.offset.y > 150) closeTray();
                // console.log("offset", info.offset.y);
                // console.log("velocity", info.velocity.y);
              }}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                style={{ padding: "10px" }}
                className="d-flex justify-content-center align-items-center"
              >
                <div
                  style={{
                    width: "70px",
                    height: "6px",
                    borderRadius: "100px",
                    backgroundColor: "#E3E3E9",
                  }}
                ></div>
              </div>

              <div
                className="overflow-auto"
                style={{ padding: "0px 12px 12px" }}
                onClick={(e) => e.stopPropagation()}
              >
                {text && (
                  <div
                    className="d-flex align-items-center justify-content-between"
                    style={{
                      padding: "8px 0px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: "18px",
                        color: "black",
                      }}
                    >
                      {text}
                    </div>
                    <svg
                      onClick={() => closeTray()}
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="26" height="26" rx="13" fill="#E3E3E9" />
                      <path
                        d="M17.0302 7.76998C17.2254 7.57492 17.542 7.57479 17.7372 7.76998C17.932 7.96521 17.9321 8.28187 17.7372 8.47701L13.6483 12.5649L17.7372 16.6538L17.8007 16.7319C17.9288 16.9259 17.9079 17.1899 17.7372 17.3608C17.5665 17.5314 17.3023 17.553 17.1083 17.4253L17.0302 17.3608L12.9413 13.2719L8.85342 17.3608C8.65823 17.5559 8.34163 17.5558 8.14639 17.3608C7.95119 17.1656 7.95125 16.849 8.14639 16.6538L12.2343 12.5649L8.14639 8.47701C7.95117 8.28178 7.95124 7.96524 8.14639 7.76998C8.34165 7.57472 8.65816 7.57472 8.85342 7.76998L12.9413 11.8579L17.0302 7.76998Z"
                        fill="#676A79"
                      />
                    </svg>
                  </div>
                )}
                {cloneElement(children, { closeTray })}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default BottomTray;
